export {
  CookiesConsentFloatingBtn,
  CookiesConsentFloatingBtnWithStyles,
  CookiesConsentFloatingBtnStyled,
} from './CookiesConsentFloatingBtn'
